export const SW_MEDIA_PATHS = [
	'/_matrix/client/v1/media/download',
	'/_matrix/client/v1/media/thumbnail'
] as const;
export const SW_SESSION_TIMEOUT_MS = 3000;
export const SW_MESSAGE_SET_SESSION = 'setSession';
export const SW_MESSAGE_REQUEST_SESSION = 'requestSession';
export const UPLOAD_PROGRESS_THROTTLE_MS = 200;
